import { ReactNode } from 'react'
import PointsDisplay from '../../ArcadeLeaderboard/PointsDisplay'

type Props = {
  pointsData: any // @todo - stevei - This is a placeholder until a schema is known
  offSeason?: boolean
}

const ArcadePointValuesGrid = ({ pointsData, offSeason = false }: Props) => {
  return (
    <div className="w-full">
      <div className="flex justify-between text-gray-300 pricing-sm uppercase pb-1 px-3">
        <span>Rarity</span>
        <span>Arcade Point Value</span>
      </div>
      {pointsData.map((rarity, index) => (
        <ArcadePointValuesGridItem
          key={index}
          {...rarity}
          offSeason={offSeason}
        />
      ))}
    </div>
  )
}

const ArcadePointValuesGridItem = ({
  badge,
  points,
  offSeason = false
}: {
  badge: ReactNode
  points: string
  offSeason?: boolean
}) => {
  return (
    <div className="flex justify-between items-center border-b border-gray-800 py-2 px-3">
      {badge}
      <div className="flex items-center text-white font-bold text-sm gap-[4px] justify-center">
        {offSeason ? (
          <span className="body-md text-gray-300">TBA</span>
        ) : (
          <PointsDisplay value={points} />
        )}
      </div>
    </div>
  )
}

export default ArcadePointValuesGrid
